export const ROUTE_PATH = {
  provideAccount: '/provide/account',
  provideAccountDetail: '/provide/detail/',
  guide: '/danh-sach-huong-dan',
  guideView: '/huong-dan',
  forgotPassword: '/forgot-password',
};
